import { all, takeLatest, put } from 'redux-saga/effects';
import {
    CREATE_THEME,
    UPDATE_THEME,
    DELETE_THEME,
} from './constants';
import {
    requestCreateTheme,
    requestUpdateTheme,
    requestDeleteTheme
} from './api';
import {
    createThemeSuccess,
    updateThemeSuccess,
    deleteThemeSuccess,
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{theme, type}>>}
 */
function* createTheme( actionObj ) {
    const theme = yield requestCreateTheme();
    if ( theme ) {
        yield put( createThemeSuccess( theme, actionObj.widget ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{themes, deletedID, type}>>}
 */
function* deleteTheme( actionObj ) {
    const themes = yield requestDeleteTheme( actionObj.id );
    if ( themes ) {
        yield put( deleteThemeSuccess( themes, actionObj.widget, actionObj.id ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{widget, theme, type}>>}
 */
function* updateTheme( actionObj ) {
    const requestObject = { [ actionObj.themePart ]: actionObj.themePartValue };
    const theme = yield requestUpdateTheme( actionObj.id, requestObject );
    if ( theme ) {
        yield put( updateThemeSuccess( theme, actionObj.widget ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchAppearance() {
    yield takeLatest( CREATE_THEME, createTheme );
    yield takeLatest( UPDATE_THEME, updateTheme );
    yield takeLatest( DELETE_THEME, deleteTheme );
}

function* appearanceSaga() {
    yield all( [
        watchAppearance()
    ] );
}

export default appearanceSaga;
